import React, { Suspense, lazy, Fragment, useEffect } from 'react';
import './App.css';
import { Routes, Route, Navigate, useLocation, useNavigate, Outlet } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import NavBar from './components/navbar/NavBar';
import Sidebar from './components/sidebar/Sidebar';
import Footer from './components/footer/Footer';
import FallBack from './components/fallback/FallBack';
import Toast from './components/toastify'
import { setSidebarOpen } from './redux/reducer/userReducer';
const PromotionalCodeUsers = lazy(() => import('./pages/Discounts/PromotionalCodesUsers'));
const OrderList = lazy(() => import('./pages/Order/OrderList'));
const ChallanList = lazy(() => import('./pages/Order/ChallanList'));
const IncompleteOrderList = lazy(() => import('./pages/Order/IncompleteOrderList'));
const OrderDetails = lazy(() => import('./pages/Order/OrderDetails'));

const OfflinePaymentCreate = lazy(() => import('./pages/Order/OfflinePaymentCreate'));
const Favourite = lazy(() => import('./pages/Favourites/Favourite'));
const PopularCourse = lazy(() => import('./pages/PopularCourse/PopularCourse'));
const Classes = lazy(() => import('./pages/Classes/Classes'));
const Login = lazy(() => import('./pages/Login/Login'));
const ForgotPassword = lazy(() => import('./pages/ForgotPassword/ForgotPassword'))
const VerifyOtp = lazy(() => import('./pages/ForgotPassword/VerifyOtp'))
const ResetPassword = lazy(() => import('./pages/ResetPassword/ResetPassword'))
const UploadFile = lazy(() => import('./pages/Courses/UploadCourses/UploadFile'));
// const CreateUser = lazy(() => import('./pages/User Management/Users/CreateUser'));
const Subjects = lazy(() => import('./pages/Subjects/Subjects'));
const CourseDetails = lazy(() => import('./pages/CourseDetails/CourseDetails'));
const UserDetails = lazy(() => import('./pages/User Management/Users/UserDetails'));
const Roles = lazy(() => import('./pages/User Management/Roles/Roles'));
const EditRoles = lazy(() => import('./pages/User Management/Roles/EditRoles'));
const CreateNewRole = lazy(() => import('./pages/User Management/Roles/CreateNewRole'));
const Categories = lazy(() => import('./pages/Categories/Categories'));
const UploadStatus = lazy(() => import('./pages/Courses/UploadCourses/UploadStatus'));
const CategoryCreate = lazy(() => import('./pages/Categories/CategoryCreate'));
const Subcategories = lazy(() => import('./pages/Categories/Subcategories'));
const EditSubcategory = lazy(() => import('./pages/Categories/EditSubCategory'));
const EditCategory = lazy(() => import('./pages/Categories/EditCategory'));
const EditSubject = lazy(() => import('./pages/Subjects/EditSubject'));
const SubjectDetails = lazy(() => import('./pages/Subjects/ViewSubject'));
const Goal = lazy(() => import('./pages/Goals/Goals'));
const EditGoal = lazy(() => import('./pages/Goals/EditGoal'));
const UploadCourseContent = lazy(() => import('./pages/Courses/UploadCourses/UploadCourseContent'));
const ZoomUsers = lazy(() => import('./pages/User Management/ZoomUsers/ZoomUsers'));
const CreateZoomUsers = lazy(() => import('./pages/User Management/ZoomUsers/CreateZoomUsers'));
const ZoomUsersDetails = lazy(() => import('./pages/User Management/ZoomUsers/ViewZoomUsers'));
const EditUser = lazy(() => import('./pages/User Management/Users/EditUser'));
const CreateEditCourse = lazy(() => import('./pages/CreateCourse/CreateEditCourse.jsx'));
const AppContent = lazy(() => import('./pages/AppContent/AppContent'));
const AppContentDetails = lazy(() => import('./pages/AppContent/ViewAppContent'));
const CreateAppContent = lazy(() => import('./pages/AppContent/CreateAppContent'));
const CourseContentUploadBulk = lazy(() => import('./pages/CourseContentUploadBulk/CourseContentUploadBulk'));
const CourseTypeList = lazy(() => import('./pages/CourseType/CourseTypes'));
const Settings = lazy(() => import('./pages/Settings/Settings'));
const EditSettings = lazy(() => import('./pages/Settings/EditSettings'));
const EditCourseType = lazy(() => import('./pages/CourseType/EditCourseType'));
const ViewSettings = lazy(() => import('./pages/Settings/ViewSettings'));
const QuizList = lazy(() => import('./pages/Quiz/QuizList'));
const EditQuiz = lazy(() => import('./pages/Quiz/EditQuiz'));
const QuizDetails = lazy(() => import('./pages/Quiz/QuizDetails'));
const Batches = lazy(() => import('./pages/Batches/ListBatches'));
const EditBatch = lazy(() => import('./pages/Batches/EditBatches'));
const BatchDetails = lazy(() => import('./pages/Batches/BatchDetails'));
const Students = lazy(() => import('./pages/Students/Students'));
const ExtendsStudents = lazy(() => import('./pages/Students/ExtandsStudents'));
const CreateExtandsUser = lazy(() => import('./pages/Students/CreateExtandsUser'));
const InCompleteStudents = lazy(() => import('./pages/Students/InCompleteStudents'));
const StudentsDetails = lazy(() => import('./pages/Students/StudentsDetails'));
const BatchClass = lazy(() => import('./pages/BatchClass/ListBatchClass'));
// const CreateClass = lazy(() => import('./pages/BatchClass/CreateClass'));
const EditClass = lazy(() => import('./pages/BatchClass/EditClass'));
const ReviewBatchClass = lazy(() => import('./pages/BatchClass/ReviewBatchClass'));
const ModifyBatchClass = lazy(() => import('./pages/BatchClass/ModifyBatchClass'));
const BatchClassDetails = lazy(() => import('./pages/BatchClass/BatchClassDetails'))
const UploadBatchClass = lazy(() => import('./pages/BatchClass/UploadBatchClasses'));
const Discount = lazy(() => import('./pages/Discounts/Discount'));
const ListDiscount = lazy(() => import('./pages/Discounts/ListDiscount'));
const EditProfile = lazy(() => import('./pages/EditProfile/EditProfile'));
const UploadTeacher = lazy(() => import('./pages/User Management/Users/TeacherUpload'));
const ZoomStartLiveClass = lazy(() => import('./pages/ZoomStartClass/ZoomStartClass'));
const JitsiStartLiveClass = lazy(() => import('./pages/ZoomClasses/TeacherLivePage'));
const ClassroomPage = lazy(() => import('./pages/ZoomClasses/ClassroomPage'));
const Dashboard = lazy(() => import('./pages/DashBoard/Dashboard'));
const Courses = lazy(() => import('./pages/Courses/Courses'));
const OfflineCourses = lazy(() => import('./pages/OfflineCourses/OfflineCourses'));
const CreateEditCourseOffline = lazy(() => import('./pages/OfflineCourses/CreateCourse/CreateEditCourseOffline'));

const Users = lazy(() => import('./pages/User Management/Users/Users'));
const UploadQuiz = lazy(() => import('./pages/Quiz/UploadQuiz'));
const UploadTopicFile = lazy(() => import('./pages/CourseDetails/UploadTopicFile'));
const UploadPromotionalCode = lazy(() => import('./pages/Discounts/UploadPromotionalCode'));
const TestimonialList = lazy(() => import('./pages/Testimonial/TestimonialList'));
const TestimonialDetails = lazy(() => import('./pages/Testimonial/TestimonialDetails'));
const TestimonialCreate = lazy(() => import('./pages/Testimonial/TestimonialCreate'));
const TestimonialEdit = lazy(() => import('./pages/Testimonial/TestimonialEdit'));
const UploadStudents = lazy(() => import('./pages/Students/UploadStudents'));
const UpdateCurrentClass = lazy(() => import('./pages/Students/UpdateCurrentClass'));
const CompanyDetailList = lazy(() => import('./pages/CompanyDetails/CompanyDetailList'));
const EditCompanyDetail = lazy(() => import('./pages/CompanyDetails/EditCompanyDetails'));
const FavouriteCategory = lazy(() => import('./pages/Favourites/FavouriteCategory'));
const FavouriteSubCategory = lazy(() => import('./pages/Favourites/FavouriteSubCategory'))
const Download = lazy(() => import('./pages/Downloads/DownloadsCategoryList'))
const DownloadCreate = lazy(() => import('./pages/Downloads/CreateDownloadCategory'))
const DownloadSubCategory = lazy(() => import('./pages/Downloads/DownloadSubCategory'))
const CreateDownloadSubcategory = lazy(() => import("./pages/Downloads/CreateDownloadSubCategory"))
const Downloads = lazy(() => import("./pages/Downloads/Downloads"))
const CreateDownloads = lazy(() => import("./pages/Downloads/CreateDownloads"))
const DownloadGroup = lazy(() => import("./pages/Downloads/DownloadGroup"))
const CreateDownloadGroup = lazy(() => import("./pages/Downloads/CreateDownloadGroup"))
const AuditProcess = lazy(() => import("./pages/AuditProcess/AuditProcess"))
const ZoomClasses = lazy(() => import("./pages/ZoomClasses/ZoomClasses"))
const AuditUsersList = lazy(() => import("./pages/User Management/AuditUser/ListAuditUser"))
const CreateAuditUser = lazy(() => import("./pages/User Management/AuditUser/CreateAuditUser"))

const MasterPasswordProfile = lazy(() => import("./pages/User Management/AuditUser/AuditMasterPassword"))
const EditStudent = lazy(() => import("./pages/Students/EditStudent/EditStudent"))
const NoticeBoard = lazy(() => import('./pages/NoticeBoard/NoticeBoard'))
const NoticeBoardCreate = lazy(() => import('./pages/NoticeBoard/NoticeBoardCreate'))
const ClassAttendance = lazy(() => import("./pages/Reports/ClassAttendance"))
const ReportAnalysis = lazy(() => import("./pages/Reports/ReportAnalysis"))
const TeacherAttendance = lazy(() => import("./pages/Reports/TeacherAttendance"))
const TeacherEngagement = lazy(() => import("./pages/Reports/TeacherEngagementList.jsx"))
const Notification = lazy(() => import('./pages/Notifications/Notification'))
const NotificationCreate = lazy(() => import('./pages/Notifications/NotificationCreate'));
const NotificationDetails = lazy(() => import('./pages/Notifications/NotificationDetails'));
const UploadNotification = lazy(() => import('./pages/Notifications/UploadNotification'));
const JeeMarks = lazy(() => import('./pages/JeeMarks/JeeMarks'))
const JeeMarksCalculateCreate = lazy(() => import('./pages/JeeMarks/JeeMarksCalculateCreate'));
const JeeMarksDetails = lazy(() => import('./pages/JeeMarks/JeeMarksDetails'));
const SmsList = lazy(() => import("./pages/SmsPannel/SmsList"))
const SmsCreate = lazy(() => import("./pages/SmsPannel/SmsCreate"))
const SMSDetails = lazy(() => import("./pages/SmsPannel/smsDetails"))
const BannerList = lazy(() => import("./pages/Banner/BannerList"))
const ResultBannerList = lazy(() => import("./pages/ResultBanner/ResultBannerList"))
const ResultCreateBanner = lazy(() => import("./pages/ResultBanner/ResultBannerCreate"))
const CreateBanner = lazy(() => import("./pages/Banner/BannerCreate"))
const CourseMedium = lazy(() => import('./pages/CourseMedium/CourseMedium'))
const ListCourseMedium = lazy(() => import('./pages/CourseMedium/CousrseMediumList'))
const ListHomeTestSeries = lazy(() => import('./pages/HomeTestSeries/ListHomeTestSeries'))
const CreateHomeTestSeries = lazy(() => import('./pages/HomeTestSeries/CreateHomeTestSeries'))
const TeacherCalendar = lazy(() => import('./pages/BatchClass/BatchClassCalendar'))
const BatchClassTypeList = lazy(() => import('./pages/BatchClassType/BatchClassTypeList'))
const BatchClassTypeCreate = lazy(() => import('./pages/BatchClassType/BatchClassTypeCreate'))
const SmsLogList = lazy(() => import("./pages/SmsLog/SmsLogList"))
const SMSLogDetails = lazy(() => import("./pages/SmsLog/SMSLogDetails"))
const SamplePaper = lazy(() => import("./pages/SamplePaper/SamplePaper"))
const EditSamplePaper = lazy(() => import("./pages/SamplePaper/EditSamplePaper"))
const Brochure = lazy(() => import("./pages/Brochure/Brochure"))
const EditBrochure = lazy(() => import("./pages/Brochure/EditBrochure"))
const TestPattern = lazy(() => import("./pages/TestPattern/TestPattern"))
const EditTestPattern = lazy(() => import("./pages/TestPattern/EditTestPattern"))
const CurrentClassList = lazy(() => import("./pages/CurrentClass/CurrentClassList"))
const EditCurrentClass = lazy(() => import("./pages/CurrentClass/EditCurrentClass"))
const CampusList = lazy(() => import("./pages/Campus/CampusList"))
const EditCreateCampus = lazy(() => import("./pages/Campus/EditCreateCampus"))
const CampusCitiesList = lazy(() => import("./pages/CampusCities/CampusCitiesList"))
const EditCreateCampusCities = lazy(() => import("./pages/CampusCities/EditCreateCampusCities"))
const OnlineSessionsList = lazy(() => import("./pages/OnlineSessions/OnlineSessionsList"))
const OnlineSessionCreate = lazy(() => import("./pages/OnlineSessions/OnlineSessionCreate"))

//handout user
const HandoutUser = lazy(() => import("./pages/CourseHandout/HandoutUser/HandoutUserList"))
const CreateHandoutUser = lazy(() => import("./pages/CourseHandout/HandoutUser/HandoutUser"))
const CourseHandoutList = lazy(() => import("./pages/CourseHandout/CourseHandout/CourseHandoutList"))
const CreateHandout = lazy(() => import("./pages/CourseHandout/CourseHandout/CreateCourseHandout"))
const ReviewHandoutList = lazy(() => import("./pages/CourseHandout/ReviewCourseHandout/ReviewHandoutList"))
const ReviewEditHandout = lazy(() => import("./pages/CourseHandout/ReviewCourseHandout/ReviewHandoutEdit"))
const HandoutViewDetails = lazy(() => import("./pages/CourseHandout/ReviewCourseHandout/HandoutDetails"))
const ShowNoticeBoard = lazy(() => import("./pages/NoticeBoard/ShowNoticeBoard"));
const GetAllNotifications = lazy(() => import("./pages/AllNotifications/AllNotifications"));

const Support = lazy(() => import("./pages/Support/SupportList"))
const UserSupport = lazy(() => import("./pages/Support/SupportUser"))

const UploadBatch = lazy(() => import("./pages/Batches/UploadBatches"))
const BatchChanges = lazy(() => import("./pages/BatchChanges/BatchChanges"))
const UploadBatchChanges = lazy(() => import('./pages/BatchChanges/UploadBatchChange'))
const NewBatchChanges = lazy(() => import('./pages/BatchChanges/NewBatchChange'))
const NewGatePass = lazy(() => import('./pages/GatePass/NewGatePass'))
const GatePassListing = lazy(() => import('./pages/GatePass/GatePassListing'))

const ExamCalendar = lazy(() => import('./pages/Exams/ExamCalendar/ExamCalendar'))
const ExamCalendarEdit = lazy(() => import('./pages/Exams/ExamCalendar/ExamCalendarEdit'))
const NoticeManagement = lazy(() => import('./pages/NoticeManagement/NoticeManagement'))
const NoticeManagementEdit = lazy(() => import('./pages/NoticeManagement/NoticeManagementEdit'))
const DocumentsManagement = lazy(() => import('./pages/DocumentsManagement/DocumentsManagement'))
const DocumentsManagementEdit = lazy(() => import('./pages/DocumentsManagement/DocumentsManagementEdit'))
const Documents = lazy(() => import('./pages/Documents/Documents'))
const StudyContentList = lazy(() => import('./pages/StudyContent/StudyContentList'))
const StudyContentEdit = lazy(() => import('./pages/StudyContent/StudyContentEdit'))

const ExamSubject = lazy(() => import('./pages/Exams/Subjects/SubjectList'))
const CreateESubject = lazy(() => import('./pages/Exams/Subjects/CreateEsubject'))
const EsubjectDetails = lazy(() => import('./pages/Exams/Subjects/ESubjectDetails'))
const UploadTopicSubTopic = lazy(() => import('./pages/Exams/Subjects/Topics/UploadTopicSubTopic'))

const QuestionTypeList = lazy(() => import('./pages/Exams/QuestionType/QuestionTypeList'));
const QuestionTypeCreate = lazy(() => import('./pages/Exams/QuestionType/QuestionTypeCreate'));

const PaperTypeList = lazy(() => import('./pages/Exams/PaperType/PaperTypeList'));
const PaperTypeCreate = lazy(() => import('./pages/Exams/PaperType/PaperTypeCreate'));

const SubjectPaperCreate = lazy(() => import('./pages/Exams/SubjectPaper/SubjectPaperCreate'));
const SubjectPaperList = lazy(() => import('./pages/Exams/SubjectPaper/SubjectPaperList'));
const SubjectPaperView = lazy(() => import('./pages/Exams/SubjectPaper/SubjectPaperView'));
const SubjectPaperPreview = lazy(() => import('./pages/Exams/SubjectPaper/SubjectPaperPreview'));
const UploadSubjectQuestion = lazy(() => import('./pages/Exams/SubjectPaper/UploadSubjectQuestion'));

const ManageRules = lazy(() => import('./pages/Exams/Rules/RulesList'))
const CreateRules = lazy(() => import('./pages/Exams/Rules/CreateRules'))

const SectionNameList = lazy(() => import('./pages/Exams/SectionName/SectionNameList'))
const SectionNameCreate = lazy(() => import('./pages/Exams/SectionName/SectionNameCreate'))

const DifficultyLevelList = lazy(() => import('./pages/Exams/DifficultyLevel/DifficultyLevelList'))
const DifficultyLevelCreate = lazy(() => import('./pages/Exams/DifficultyLevel/DifficultyLevelCreate'))

const TestPaperList = lazy(() => import('./pages/Exams/TestPaper/TestPaperList'))
const TestPaperCreate = lazy(() => import('./pages/Exams/TestPaper/TestPaperCreate'))
const TestPaperView = lazy(() => import('./pages/Exams/TestPaper/TestPaperView'))

const GroupPaperList = lazy(() => import('./pages/Exams/GroupPaper/GroupPaperList'));
const GroupPaperCreate = lazy(() => import('./pages/Exams/GroupPaper/GroupPaperCreate'));
const ViewGroupPaper = lazy(() => import('./pages/Exams/GroupPaper/ViewGroupPaper'));
const ViewGroupResult = lazy(() => import('./pages/Exams/GroupPaper/ViewGroupResult'));

const ExamPaperList = lazy(() => import('./pages/Exams/ExamPaper/ExamPaperList'));
const ExamPaperCreate = lazy(() => import('./pages/Exams/ExamPaper/ExamPaperCreate'));
const ExamPaperEdit = lazy(() => import('./pages/Exams/ExamPaper/ExamPaperEdit'));
const LiveResult = lazy(() => import('./pages/Exams/LiveResult/LiveResult'));
const ViewLiveResult = lazy(() => import('./pages/Exams/LiveResult/ViewLiveResult'));
const UploadModifyResult = lazy(() => import('./pages/Exams/LiveResult/UploadModifyResult'))
const UploadAbsent = lazy(() => import('./pages/Exams/LiveResult/UploadAbsent'))
const UploadModifyGrpResult = lazy(() => import('./pages/Exams/GroupPaper/UploadModifyGrpResult'))
const ResultAnalysis = lazy(() => import('./pages/Exams/LiveResult/ResultAnalysis'));
const ViewLogResponse = lazy(() => import('./pages/Exams/LiveResult/ViewLogResponse'));
const UploadOfflineResult = lazy(() => import('./pages/Exams/LiveResult/UploadOfflineResult'))
const UploadOMRSheet = lazy(() => import('./pages/Exams/LiveResult/UploadOMRSheet'))
const ChallengesList = lazy(() => import('./pages/Exams/LiveResult/ChallengesList'));
const UploadAnswerPDFSheet = lazy(() => import('./pages/Exams/LiveResult/UploadAnswerPDFSheet'))

const StudentSidebarManage = lazy(() => import('./pages/StudentSidebarManage/StudentSidebarManage'));
const UploadStudentsFromCourses = lazy(() => import('./pages/Courses/UploadCourses/UploadStudentsFromCourses'));

const UploadNoticeBoard = lazy(() => import("./pages/NoticeBoard/UploadNoticeBoard"))
const UploadSmsPanel = lazy(() => import('./pages/SmsPannel/UploadSmsPanel'))

const CreateESubjectGoals = lazy(() => import('./pages/Exams/E-SubjectGoals/CreateESubjectGoals'))
const ESubjectGoalsList = lazy(() => import('./pages/Exams/E-SubjectGoals/ESubjectGoalsList'));

const AvatarList = lazy(() => import('./pages/Avatar/AvatarList'));
const CreateAvatar = lazy(() => import('./pages/Avatar/CreateAvatar'));

const ExamCenterList = lazy(() => import('./pages/Exams/ExamCenter/ExamCenterList'));
const CreateExamCenter = lazy(() => import('./pages/Exams/ExamCenter/CreateExamCenter'));
const AdmitCard = lazy(() => import('./pages/Courses/AdmitCard'));

const PaymentLinkList = lazy(() => import('./pages/PaymentLink/PaymentLinkList'));
const PaymentLinkCreate = lazy(() => import('./pages/PaymentLink/PaymentLinkCreate'));
const PaymentLinkDetails = lazy(() => import('./pages/PaymentLink/PaymentLinkDetails'));

const ListScholarship = lazy(() => import('./pages/Scholarship/ListScholarship'));
const EditScholarship = lazy(() => import('./pages/Scholarship/EditScholarship'));
const ListSparkStudents = lazy(() => import('./pages/Spark/ListSparkStudents'));
const EditSparkStudent = lazy(() => import('./pages/Spark/EditSparkStudent'));
const UploadSparkStudent = lazy(() => import('./pages/Spark/UploadSparkStudent'));
// const ScholarshipDetails = lazy(() => import('./pages/Scholarship/ScholarshipDetails'));
const UploadScholarship = lazy(() => import('./pages/Scholarship/UploadScholarship'));
const InstallmentList = lazy(() => import('./pages/Installment/InstallmentList'));
const InstallmentDetails = lazy(() => import('./pages/Installment/InstallmentDetails'));
// const ChannelPartners = lazy(() => import('./pages/Discounts/ChannelPartners'));
// const ChannelPartnerDetails = lazy(() => import('./pages/Discounts/ChannelPartnerDetails'));
const TestEngagement = lazy(() => import("./pages/Reports/TestEngagementList"))
const RegUserReportAnalysis = lazy(() => import('./pages/Reports/RegUserReportAnalysis'));
const UserReportAnalysis = lazy(() => import('./pages/Reports/UserReportAnalysis'));
const AdmissionReport = lazy(() => import('./pages/Reports/AdmissionReport'));
const FacultyLoadBalanceReport = lazy(() => import('./pages/Reports/FacultyLoadBalanceReport'));
const RevenueReport = lazy(() => import('./pages/Reports/RevenueReport'));
const BatchReport = lazy(() => import('./pages/Reports/BatchReport'));
const ProfileReport = lazy(() => import('./pages/Reports/ProfileReport'));
const CourseStudentCountReport = lazy(() => import('./pages/Reports/CourseStudentCountReport'));
const CourseChangeList = lazy(() => import('./pages/CourseChange/CourseChangeList'));
const CourseChange = lazy(() => import('./pages/CourseChange/CourseChange'));
const RegisterUser = lazy(() => import('./pages/Students/RegisterUser'));
const CreateAdmitCard = lazy(() => import('./pages/CreateAdmitCard/CreateAdmitCard'));
const SearchAdmitCard = lazy(() => import('./pages/SearchAdmitCard/SearchAdmitCard'));
// const ViewOfflineResult = lazy(() => import('./pages/OfflineResult/ViewOfflineResult'));
// const OfflineResult = lazy(() => import('./pages/OfflineResult/OfflineResult'));
const LandingPageRegisterList = lazy(() => import('./pages/Reports/LandingPageRegisterList'));
const TimeTableList = lazy(() => import('./pages/BatchClass/TimeTableList'));
const AttendanceList = lazy(() => import('./pages/BatchClass/AttendanceList'))
const LiveClassParticipantList = lazy(() => import('./pages/BatchClass/LiveClassParticipantList'))
const ReviewAttendance = lazy(() => import('./pages/BatchClass/ReviewAttendance'))
const UploadAttendance = lazy(() => import('./pages/BatchClass/UploadAttendance'))
const ManageLiveClass = lazy(() => import("./pages/BatchClass/ManageLiveClass"))
const ModifyLiveClasses = lazy(() => import("./pages/BatchClass/ModifyLiveClasses"))
const EditManageLiveClass = lazy(() => import("./pages/BatchClass/EditManageLiveClass"))
const ResultPageList = lazy(() => import('./pages/ResultPage/ResultPageList'));
const ResultPageBannerList = lazy(() => import('./pages/ResultPage/ResultPageBannerList'));
const ResultPageCreate = lazy(() => import('./pages/ResultPage/ResultPageCreate'));
const AdmitCardPrint = lazy(() => import('./pages/Courses/AdmitCardPrint'));
const Challan = lazy(() => import('./pages/Order/Challan'));
const ProfileDataPrint = lazy(() => import('./pages/Reports/ProfileDataPrint'));
const ProfilePictures = lazy(() => import('./pages/Reports/ProfilePictures'));
const SPR = lazy(() => import('./pages/SPR/SPR'))
const PerformanceReportList = lazy(() => import('./pages/SPR/PerformanceReportList'))
const DRMPlayer = lazy(() => import('./pages/VideoPlayer/DRMPlayer'))

const QuestionsList = lazy(() => import('./pages/Feedback/Quesions/QuestionsList'))
const QuestionsCreate = lazy(() => import('./pages/Feedback/Quesions/QuetionsCreate'))
const FeedbacksList = lazy(() => import('./pages/Feedback/AllFeedbacks/FeedbacksList'))
const ReviewFeedbacks = lazy(() => import('./pages/Feedback/AllFeedbacks/ReviewFeedbacks'))
const UploadFeedbacks = lazy(() => import('./pages/Feedback/AllFeedbacks/UploadFeedbacks'))
const FeedbackCreate = lazy(() => import('./pages/Feedback/AllFeedbacks/FeedbackCreate'))
const TeacherFeedbacksList = lazy(() => import('./pages/Feedback/TeachersFeedbacksList'))
const TeacherFeedbackView = lazy(() => import('./pages/Feedback/TeacherFeedbackView'))
const TeacherFeedbackReport = lazy(() => import('./pages/Feedback/TeacherFeedbackReport'))
const AcademicYearList = lazy(() => import('./pages/AcademicYear/AcademicYearList'))
const AcademicYearCreate = lazy(() => import('./pages/AcademicYear/AcademicYearCreate'))
const AdminUserBatchList = lazy(() => import('./pages/AdminUserBatch/AdminUserBatchList'))
const AdminUserBatchCreate = lazy(() => import('./pages/AdminUserBatch/AdminUserBatchCreate'))
const MentorBatchList = lazy(() => import('./pages/MentorBatch/MentorBatchList'))
const MentorBatchCreate = lazy(() => import('./pages/MentorBatch/MentorBatchCreate'))
const MentorTeacherList = lazy(() => import('./pages/MentorTeacher/MentorTeacherList'))
const MentorTeacherCreate = lazy(() => import('./pages/MentorTeacher/MentorTeacherCreate'))
const UserAppointmentList = lazy(() => import('./pages/Appointment/UserAppointmentList'))
const AllAppointmentList = lazy(() => import('./pages/Appointment/AllAppointmentList'))
const AppointmentCreate = lazy(() => import('./pages/Appointment/AppointmentCreate'))
const FacultyTaskList = lazy(() => import('./pages/FacultyTask/FacultyTaskList'))
const FacultyTaskCreate = lazy(() => import('./pages/FacultyTask/FacultyTaskCreate'))
const MyTaskList = lazy(() => import('./pages/FacultyTask/MyTaskList'))
const FPRReport = lazy(() => import('./pages/Reports/FPRReport'))
const FPRReportView = lazy(() => import('./pages/Reports/FPRReportView'))
const FPRPrint = lazy(() => import('./pages/Reports/FPRPrint'))
const MasterPassword = lazy(() => import('./pages/User Management/MasterPassword.jsx'));
const StudentPassword = lazy(() => import('./pages/User Management/StudentPassword.jsx'));
const UserActivity = lazy(() => import('./pages/UserActivity/UserActivity'))
const UserActivityView = lazy(() => import('./pages/UserActivity/UserActivityView'))
const ListTeacherBatches = lazy(() => import('./pages/Batches/ListTeacherBatches'))
const CoureRegistration = lazy(() => import('./pages/Order/CoureRegistration'));
const ListHostel = lazy(() => import('./pages/Spark/Hostel/ListHostel'));
const EditHostel = lazy(() => import('./pages/Spark/Hostel/EditHostel'));
const ListSparkRegistration = lazy(() => import('./pages/Spark/SparkRegistration/ListSparkRegistration'));
const EditRegistration = lazy(() => import('./pages/Spark/SparkRegistration/EditRegistration'));
const ViewRegistration = lazy(() => import('./pages/Spark/SparkRegistration/ViewRegistration'));
const MasterEnquiriesList = lazy(() => import('./pages/Enquiries/MasterEnquiriesList'));
const CallbackEnquiriesList = lazy(() => import('./pages/Enquiries/CallbackEnquiriesList'));
const EnquiriesList = lazy(() => import('./pages/Enquiries/EnquiriesList'));
const EnquiryCreate = lazy(() => import('./pages/Enquiries/EnquiryCreate'));
const ParentSupportList = lazy(() => import('./pages/ParentSupport/ParentSupportList'));
const ParentSupportEdit = lazy(() => import('./pages/ParentSupport/ParentSupportEdit'));
const ParentSupportAccessList = lazy(() => import('./pages/ParentSupportAccess/ParentSupportAccessList'));
const ParentSupportAccessCreate = lazy(() => import('./pages/ParentSupportAccess/ParentSupportAccessCreate'));

const MessageGroup = lazy(() => import('./pages/MessageGroup/MessageGroup'))
const MessageGroupEdit = lazy(() => import('./pages/MessageGroup/MessageGroupEdit'));
const Messages = lazy(() => import('./pages/Messages/Messages'))
const MessagesCreate = lazy(() => import('./pages/Messages/MessagesCreate'));
const MessagesDetails = lazy(() => import('./pages/Messages/MessagesDetails'));
const StudentAcademicData = lazy(() => import('./pages/Reports/StudentAcademicData'));
const VideosList = lazy(() => import('./pages/Videos/VideosList'))
const VideoCreate = lazy(() => import('./pages/Videos/VideoCreate'))
const AgentEnquiriesList = lazy(() => import('./pages/CRM/AgentEnquiriesList'));
const AgentEnquiryEdit = lazy(() => import('./pages/CRM/AgentEnquiryEdit'));
const MasterAgentEnquiriesList = lazy(() => import('./pages/CRM/MasterAgentEnquiriesList'));
const MasterAgentEnquiryEdit = lazy(() => import('./pages/CRM/MasterAgentEnquiryEdit'));
const UploadAgentTasks = lazy(() => import('./pages/CRM/UploadTasks'));
const IdCardList = lazy(() => import('./pages/IdCard/IdCardList'));
const UploadIDCardStatus = lazy(() => import('./pages/IdCard/UploadStatus'));
const YouTubeVideosList = lazy(() => import('./pages/YouTubeVideos/YouTubeVideosList'))
const YouTubeVideoCreate = lazy(() => import('./pages/YouTubeVideos/YouTubeVideoCreate'))
const CounsellingReport = lazy(() => import('./pages/Couselling/CounsellingReport'));
const SlotList = lazy(() => import('./pages/Couselling/SlotList'));
const EditTimeSlot = lazy(() => import('./pages/Couselling/EditTimeSlot'));
const HomePageButton = lazy(() => import('./pages/HomePageButton/HomePageButton'));
const GalleryEventList = lazy(() => import('./pages/Gallery/GalleryEventList'));
const AddEditGalleryPhotos = lazy(() => import('./pages/Gallery/AddEditGalleryPhotos'));
const HeadOfficeRegistration = lazy(() => import('./pages/HeadOfficeRegistration/HeadOfficeRegistration'));
const ChannelPartnerList = lazy(() => import('./pages/ChannelPartner/ChannelPartnerList'));
const ChannelPartnerCreate = lazy(() => import('./pages/ChannelPartner/ChannelPartnerCreate'));
const ChannelPartnerDetails = lazy(() => import('./pages/ChannelPartner/ChannelPartnerDetails'));
const UploadChannelPartnerStudent = lazy(() => import('./pages/ChannelPartner/UploadChannelPartnerStudent'));


function App() {
  const { user } = useSelector(state => state.auth);
  const dispatch = useDispatch();
  const { sidebarOpen } = useSelector(state => state.users)
  const { pathname } = useLocation();
  const navigate = useNavigate();

  // const getMenuUrls = (menuData) =>
  //   menuData.flatMap((menuItem) => [
  //     `/${menuItem.menuURL}`,
  //     ...getMenuUrls(menuItem.subMenus),
  //   ]);
  // const menuUrls = [...new Set(getMenuUrls(user?.menuList))];
  // useEffect(()=>{
  //   if(!menuUrls.includes(pathname)){
  //     // navigate("/courses")
  //   }
  // },[pathname])


  const showNavBar = () => {
    return (user && pathname != '/print-admit-card' && pathname != '/challan-data' && pathname != '/fpr-print' && !pathname.includes('/profile-data') && !pathname.includes('/meeting-id') && !pathname.includes('/ntsc-meeting-room') && !pathname.includes('/ntsc-meeting-class') && !pathname.includes('/video-player') && !pathname.includes('/performance-report'))
  }

  return (
    <div className="wrapper" style={{ position: 'relative' }}>
      {showNavBar() && <NavBar setShowSidebar={() => dispatch(setSidebarOpen())} />}
      {showNavBar() && <div className={sidebarOpen ? "sidebar-nav sidebar-open" : "sidebar-close"}><div id="sidebar-overlay" onClick={() => dispatch(setSidebarOpen())}></div>
        <Sidebar /></div>}
      <Suspense fallback={<FallBack />}>
        <Routes>
          <Route path="/" element={
            user ? <Navigate to="/dashboard" replace /> : <Login />
          } />
          <Route path="/forgot-password" element={<ForgotPassword />} />

          <Route path="/verify-otp" element={< VerifyOtp />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/print-admit-card" element={<AdmitCardPrint />} />
          <Route path="/fpr-print" element={<FPRPrint />} />
          <Route path="/challan-data" element={<Challan />} />
          <Route path="/profile-data" element={<ProfileDataPrint />} />
          <Route path="/profile-pictures" element={<ProfilePictures />} />
          <Route path="/performance-report" element={<PerformanceReportList />} />
          <Route path="/video-player/:videoId" element={<DRMPlayer />} />
          <Route path="/meeting-id/:id" element={
            <PrivateRoute>
              <ZoomStartLiveClass />
            </PrivateRoute>}
          />
          <Route path="/ntsc-meeting-room/:id" element={
            <PrivateRoute>
              <JitsiStartLiveClass />
            </PrivateRoute>}
          />
          <Route path="/ntsc-meeting-class/:id" element={
            <PrivateRoute>
              <ClassroomPage />
            </PrivateRoute>}
          />
          <Route path="/dashboard" element={
            <PrivateRoute>
              <Dashboard />
            </PrivateRoute>
          } />
          <Route path="/register-user" element={
            <PrivateRoute>
              <RegisterUser />
            </PrivateRoute>}
          />
          <Route path="create-admit-card" element={
            <PrivateRoute>
              <CreateAdmitCard />
            </PrivateRoute>}
          />
          <Route path="/admit-card" element={
            <PrivateRoute>
              <SearchAdmitCard />
            </PrivateRoute>}
          />
          <Route path="/time-table" element={
            <PrivateRoute>
              <TimeTableList />
            </PrivateRoute>}
          />
          <Route path="/student-performance-report" element={
            <PrivateRoute>
              <SPR />
            </PrivateRoute>}
          />
          <Route path="/manage-live-class">
            <Route index element={
              <PrivateRoute>
                <ManageLiveClass />
              </PrivateRoute>}
            />
            <Route path="edit/:id" element={
              <PrivateRoute>
                <EditManageLiveClass />
              </PrivateRoute>} />
            <Route path="modify-class" element={
              <PrivateRoute>
                <ModifyLiveClasses />
              </PrivateRoute>}
            />
          </Route>
          <Route path="/online-course">
            <Route index element={
              <PrivateRoute>
                <Courses />
              </PrivateRoute>} />
            <Route path="upload" element={
              <PrivateRoute>
                <UploadFile />
              </PrivateRoute>} />
            <Route path="upload-course-content" element={
              <PrivateRoute>
                <UploadCourseContent />
              </PrivateRoute>} />
            <Route path="upload-student/:id" element={
              <PrivateRoute>
                <UploadStudentsFromCourses />
              </PrivateRoute>} />
            <Route path="create" element={
              <PrivateRoute>
                <CreateEditCourse />
              </PrivateRoute>} />
            <Route path="view/:id" element={
              <PrivateRoute>
                <CourseDetails />
              </PrivateRoute>} />
            <Route path="edit/:id" element={
              <PrivateRoute>
                <CreateEditCourse />
              </PrivateRoute>} />
            <Route path="upload-content/:id" element={
              <PrivateRoute>
                <CourseContentUploadBulk />
              </PrivateRoute>}
            />
            <Route path="admit-card/:id" element={
              <PrivateRoute>
                <AdmitCard />
              </PrivateRoute>}
            />

            <Route path="upload-topic-icon/:id" element={
              <PrivateRoute>
                <UploadTopicFile />
              </PrivateRoute>} />
          </Route>

          <Route path="/offline-course">
            <Route index element={
              <PrivateRoute>
                <OfflineCourses />
              </PrivateRoute>} />
            <Route path="upload" element={
              <PrivateRoute>
                <UploadFile />
              </PrivateRoute>} />
            <Route path="upload-course-content" element={
              <PrivateRoute>
                <UploadCourseContent />
              </PrivateRoute>} />
            <Route path="upload-student/:id" element={
              <PrivateRoute>
                <UploadStudentsFromCourses />
              </PrivateRoute>} />
            <Route path="create" element={
              <PrivateRoute>
                <CreateEditCourseOffline />
              </PrivateRoute>} />
            <Route path="view/:id" element={
              <PrivateRoute>
                <CourseDetails />
              </PrivateRoute>} />
            <Route path="edit/:id" element={
              <PrivateRoute>
                <CreateEditCourseOffline />
              </PrivateRoute>} />
            <Route path="upload-content/:id" element={
              <PrivateRoute>
                <CourseContentUploadBulk />
              </PrivateRoute>}
            />
            <Route path="admit-card/:id" element={
              <PrivateRoute>
                <AdmitCard />
              </PrivateRoute>}
            />

            <Route path="upload-topic-icon/:id" element={
              <PrivateRoute>
                <UploadTopicFile />
              </PrivateRoute>} />
          </Route>
          <Route path="course-medium" >
            <Route index element={
              <PrivateRoute>
                <ListCourseMedium />
              </PrivateRoute>} />
            <Route path="create" element={
              <PrivateRoute>
                <CourseMedium />
              </PrivateRoute>} />

            <Route path="edit/:id" element={
              <PrivateRoute>
                <CourseMedium />
              </PrivateRoute>} />
          </Route>
          <Route path="home-test-series" >
            <Route index element={
              <PrivateRoute>
                <ListHomeTestSeries />
              </PrivateRoute>} />
            <Route path="create" element={
              <PrivateRoute>
                <CreateHomeTestSeries />
              </PrivateRoute>} />

            <Route path="edit/:id" element={
              <PrivateRoute>
                <CreateHomeTestSeries />
              </PrivateRoute>} />
          </Route>
          <Route path="/user-activity" >
            <Route index element={
              <PrivateRoute>
                <UserActivity />
              </PrivateRoute>} />
            <Route path="view/:id" element={
              <PrivateRoute>
                <UserActivityView />
              </PrivateRoute>} />
          </Route>

          <Route path="/course-type">
            <Route index element={
              <PrivateRoute>
                <CourseTypeList />
              </PrivateRoute>} />
            <Route path="create" element={
              <PrivateRoute>
                <EditCourseType />
              </PrivateRoute>} />
            <Route path="edit/:id" element={
              <PrivateRoute>
                <EditCourseType />
              </PrivateRoute>} />
          </Route>
          <Route path="/csv-upload-status">
            <Route index element={
              <PrivateRoute>
                <UploadStatus />
              </PrivateRoute>} />
          </Route>
          <Route path="/admin-users">
            <Route index element={
              <PrivateRoute>
                <Users />
              </PrivateRoute>} />
            <Route path="create" element={
              <PrivateRoute>
                <EditUser />
              </PrivateRoute>} />
            <Route path="edit/:id" element={
              <PrivateRoute>
                <EditUser />
              </PrivateRoute>} />
            <Route path="view/:id" element={
              <PrivateRoute>
                <UserDetails />
              </PrivateRoute>} />
            <Route path="upload-teacher" element={<PrivateRoute>
              <UploadTeacher />
            </PrivateRoute>}
            />
          </Route>
          <Route path="/master-password">
            <Route index element={
              <PrivateRoute>
                <MasterPassword />
              </PrivateRoute>} />
          </Route>
          <Route path="/student-password">
            <Route index element={
              <PrivateRoute>
                <StudentPassword />
              </PrivateRoute>} />
          </Route>
          {/* <Route path="roles">
            <Route index element={
              <PrivateRoute>
                <Roles />
              </PrivateRoute>} />
            <Route path="create" element={
              <PrivateRoute>
                <CreateNewRole />
              </PrivateRoute>} />
            <Route path=":id" element={
              <PrivateRoute>
                <EditRoles />
              </PrivateRoute>} />
          </Route> */}
          <Route path="/roles">
            <Route index element={
              <PrivateRoute>
                <Roles />
              </PrivateRoute>} />
            <Route path="create" element={
              <PrivateRoute>
                <CreateNewRole />
              </PrivateRoute>} />

            <Route index path="edit/:id" element={
              <PrivateRoute>
                <EditRoles />
              </PrivateRoute>} />
          </Route>

          <Route path="/avatar">
            <Route index element={
              <PrivateRoute>
                <AvatarList />
              </PrivateRoute>} />
            <Route path="create" element={
              <PrivateRoute>
                <CreateAvatar />
              </PrivateRoute>} />
            <Route index path="edit/:id" element={
              <PrivateRoute>
                <CreateAvatar />
              </PrivateRoute>} />
          </Route>

          <Route path="/zoom-user">
            <Route index element={
              <PrivateRoute>
                <ZoomUsers />
              </PrivateRoute>} />
            <Route path="create" element={
              <PrivateRoute>
                <CreateZoomUsers />
              </PrivateRoute>} />
            <Route path="view/:id" element={
              <PrivateRoute>
                <ZoomUsersDetails />
              </PrivateRoute>} />
            <Route path="edit/:id" element={
              <PrivateRoute>
                <CreateZoomUsers />
              </PrivateRoute>} />
          </Route>

          <Route path="/class-type">
            <Route index element={
              <PrivateRoute>
                <BatchClassTypeList />
              </PrivateRoute>} />
            <Route path="Create" element={
              <PrivateRoute>
                <BatchClassTypeCreate />
              </PrivateRoute>} />
            <Route path="edit/:id" element={
              <PrivateRoute>
                <BatchClassTypeCreate />
              </PrivateRoute>} />
          </Route>
          <Route path="/online-sessions">
            <Route index element={
              <PrivateRoute>
                <OnlineSessionsList />
              </PrivateRoute>} />
            <Route path="Create" element={
              <PrivateRoute>
                <OnlineSessionCreate />
              </PrivateRoute>} />
            <Route path="edit/:id" element={
              <PrivateRoute>
                <OnlineSessionCreate />
              </PrivateRoute>} />
          </Route>

          <Route path="/subject-paper">
            <Route index element={
              <PrivateRoute>
                <SubjectPaperList />
              </PrivateRoute>} />
            <Route path="Create" element={
              <PrivateRoute>
                <SubjectPaperCreate />
              </PrivateRoute>} />
            <Route path="edit/:id" element={
              <PrivateRoute>
                <SubjectPaperCreate />
              </PrivateRoute>} />
            <Route path="view/:id" element={
              <PrivateRoute>
                <SubjectPaperView />
              </PrivateRoute>} />
          </Route>

          <Route path="/section-name">
            <Route index element={
              <PrivateRoute>
                <SectionNameList />
              </PrivateRoute>} />
            <Route path="Create" element={
              <PrivateRoute>
                <SectionNameCreate />
              </PrivateRoute>} />
            <Route path="edit/:id" element={
              <PrivateRoute>
                <SectionNameCreate />
              </PrivateRoute>} />
          </Route>

          <Route path="/difficulty-level">
            <Route index element={
              <PrivateRoute>
                <DifficultyLevelList />
              </PrivateRoute>} />
            <Route path="Create" element={
              <PrivateRoute>
                <DifficultyLevelCreate />
              </PrivateRoute>} />
            <Route path="edit/:id" element={
              <PrivateRoute>
                <DifficultyLevelCreate />
              </PrivateRoute>} />
          </Route>

          <Route path="/test-paper">
            <Route index element={
              <PrivateRoute>
                <TestPaperList />
              </PrivateRoute>} />
            <Route path="Create" element={
              <PrivateRoute>
                <TestPaperCreate />
              </PrivateRoute>} />
            <Route path="edit/:id" element={
              <PrivateRoute>
                <TestPaperCreate />
              </PrivateRoute>} />
            <Route path="view/:id" element={
              <PrivateRoute>
                <TestPaperView />
              </PrivateRoute>} />
          </Route>

          <Route path="/group-paper">
            <Route index element={
              <PrivateRoute>
                <GroupPaperList />
              </PrivateRoute>} />
            <Route path="Create" element={
              <PrivateRoute>
                <GroupPaperCreate />
              </PrivateRoute>} />
            <Route path="edit/:id" element={
              <PrivateRoute>
                <GroupPaperCreate />
              </PrivateRoute>} />
            <Route path="view/:id" element={
              <PrivateRoute>
                <ViewGroupPaper />
              </PrivateRoute>} />
            <Route path="result-analysis/:exid/:sId" element={
              <PrivateRoute>
                <ViewGroupResult />
              </PrivateRoute>} />
            <Route path="upload-result/:id" element={
              <PrivateRoute>
                <UploadModifyGrpResult />
              </PrivateRoute>} />
          </Route>
          {/* <Route path="/offline-result">
            <Route index element={
              <PrivateRoute>
                <OfflineResult />
              </PrivateRoute>} />
              <Route path="view/:id" element={
            <PrivateRoute>
              <ViewOfflineResult />
            </PrivateRoute>} />
          </Route>  */}
          <Route path="/exam-paper">
            <Route index element={
              <PrivateRoute>
                <ExamPaperList />
              </PrivateRoute>} />
            <Route path="Create" element={
              <PrivateRoute>
                <ExamPaperCreate />
              </PrivateRoute>} />
            <Route path="edit/:id" element={
              <PrivateRoute>
                <ExamPaperEdit />
              </PrivateRoute>} />
          </Route>
          <Route path="/result-declaration">
            <Route index element={
              <PrivateRoute>
                <ResultPageList />
              </PrivateRoute>} />
            <Route path="Create" element={
              <PrivateRoute>
                <ResultPageCreate />
              </PrivateRoute>} />
            <Route path="edit/:id" element={
              <PrivateRoute>
                <ResultPageCreate />
              </PrivateRoute>} />
            <Route path="banner/:id" element={
              <PrivateRoute>
                <ResultPageBannerList />
              </PrivateRoute>} />
          </Route>
          <Route path="/manage-live-result">
            <Route index element={
              <PrivateRoute>
                <LiveResult />
              </PrivateRoute>} />
            <Route path="view/:id" element={
              <PrivateRoute>
                <ViewLiveResult />
              </PrivateRoute>} />
            <Route path="upload-result/:id" element={
              <PrivateRoute>
                <UploadModifyResult />
              </PrivateRoute>} />
            <Route path="absent-upload" element={
              <PrivateRoute>
                <UploadAbsent />
              </PrivateRoute>} />
            <Route path="upload-Offline-result/:id" element={
              <PrivateRoute>
                <UploadOfflineResult />
              </PrivateRoute>} />
            <Route path="upload-omr-sheet/:id" element={
              <PrivateRoute>
                <UploadOMRSheet />
              </PrivateRoute>} />
            <Route path="upload-answer-pdf/:id" element={
              <PrivateRoute>
                <UploadAnswerPDFSheet />
              </PrivateRoute>} />
            <Route path="result-analysis/:id/:studentId" element={
              <PrivateRoute>
                <ResultAnalysis />
              </PrivateRoute>} />
            <Route path="result-analysis/view/logs/:id" element={
              <PrivateRoute>
                <ViewLogResponse />
              </PrivateRoute>} />
            <Route path="challenges/:id" element={
              <PrivateRoute>
                <ChallengesList />
              </PrivateRoute>} />
          </Route>

          {/* <Route path="/notice-board">
            <Route index element={
              <PrivateRoute>
                <NoticeBoard />
              </PrivateRoute>} />
            <Route path="Create" element={
              <PrivateRoute>
                <NoticeBoardCreate />
              </PrivateRoute>} />
            <Route path="edit/:id" element={
              <PrivateRoute>
                <NoticeBoardCreate />
              </PrivateRoute>} />
            <Route path="upload-noticeboard" element={
              <PrivateRoute>
                <UploadNoticeBoard />
              </PrivateRoute>} />
          </Route> */}

          {/* <Route path="/notice-board-messages">
            <Route index element={
              <PrivateRoute>
                <ShowNoticeBoard />
              </PrivateRoute>} />
          </Route>

          <Route path="/all-notifications">
            <Route index element={
              <PrivateRoute>
                <GetAllNotifications />
              </PrivateRoute>} />
          </Route> */}
          <Route path="/channel-partner" >
            <Route index element={
              <PrivateRoute>
                <ChannelPartnerList />
              </PrivateRoute>} />
            <Route path="Create" element={
              <PrivateRoute>
                <ChannelPartnerCreate />
              </PrivateRoute>} />
            <Route path="edit/:id" element={
              <PrivateRoute>
                <ChannelPartnerCreate />
              </PrivateRoute>} />
            <Route path="details/:id" element={
              <PrivateRoute>
                <ChannelPartnerDetails />
              </PrivateRoute>} />
            <Route path="upload" element={
              <PrivateRoute>
                <UploadChannelPartnerStudent />
              </PrivateRoute>} />
          </Route>
          <Route path="/documents-management" >
            <Route index element={
              <PrivateRoute>
                <DocumentsManagement />
              </PrivateRoute>} />
            <Route path="Create" element={
              <PrivateRoute>
                <DocumentsManagementEdit />
              </PrivateRoute>} />
            <Route path="edit/:id" element={
              <PrivateRoute>
                <DocumentsManagementEdit />
              </PrivateRoute>} />
          </Route>
          <Route path="/notice-board" >
            <Route index element={
              <PrivateRoute>
                <NoticeManagement />
              </PrivateRoute>} />
            <Route path="Create" element={
              <PrivateRoute>
                <NoticeManagementEdit />
              </PrivateRoute>} />
            <Route path="edit/:id" element={
              <PrivateRoute>
                <NoticeManagementEdit />
              </PrivateRoute>} />
          </Route>
          <Route path="/study-content" >
            <Route index element={
              <PrivateRoute>
                <StudyContentList />
              </PrivateRoute>} />
            <Route path="Create" element={
              <PrivateRoute>
                <StudyContentEdit />
              </PrivateRoute>} />
            <Route path="edit/:id" element={
              <PrivateRoute>
                <StudyContentEdit />
              </PrivateRoute>} />
          </Route>
          <Route path="/documents" >
            <Route index element={
              <PrivateRoute>
                <Documents />
              </PrivateRoute>} />
          </Route>
          <Route path="/messages">
            <Route index element={
              <PrivateRoute>
                <Messages />
              </PrivateRoute>} />
            <Route path="Create" element={
              <PrivateRoute>
                <MessagesCreate />
              </PrivateRoute>} />
            <Route path="edit/:id" element={
              <PrivateRoute>
                <MessagesCreate />
              </PrivateRoute>} />
            <Route path="clone/:id/:cloneMode" element={
              <PrivateRoute>
                <MessagesCreate />
              </PrivateRoute>} />
            <Route path="details/:id" element={
              <PrivateRoute>
                <MessagesDetails />
              </PrivateRoute>} />
          </Route>
          <Route path="/videos">
            <Route index element={
              <PrivateRoute>
                <VideosList />
              </PrivateRoute>} />
            <Route path="Create" element={
              <PrivateRoute>
                <VideoCreate />
              </PrivateRoute>} />
            <Route path="edit/:id" element={
              <PrivateRoute>
                <VideoCreate />
              </PrivateRoute>} />
          </Route>
          <Route path="/youtube-video">
            <Route index element={
              <PrivateRoute>
                <YouTubeVideosList />
              </PrivateRoute>} />
            <Route path="Create" element={
              <PrivateRoute>
                <YouTubeVideoCreate />
              </PrivateRoute>} />
            <Route path="edit/:id" element={
              <PrivateRoute>
                <YouTubeVideoCreate />
              </PrivateRoute>} />
          </Route>
          <Route path="counselling-report" >
            <Route index element={
              <PrivateRoute>
                <CounsellingReport />
              </PrivateRoute>} />
          </Route>
          <Route path="/counselling" >
            <Route index element={
              <PrivateRoute>
                <SlotList />
              </PrivateRoute>} />
            <Route path="Create" element={
              <PrivateRoute>
                <EditTimeSlot />
              </PrivateRoute>} />
            <Route path="edit/:id" element={
              <PrivateRoute>
                <EditTimeSlot />
              </PrivateRoute>} />
          </Route>
          <Route path="/home-button" >
            <Route index element={
              <PrivateRoute>
                <HomePageButton />
              </PrivateRoute>} />
          </Route>
          <Route path="/message-group">
            <Route index element={
              <PrivateRoute>
                <MessageGroup />
              </PrivateRoute>} />
            <Route path="Create" element={
              <PrivateRoute>
                <MessageGroupEdit />
              </PrivateRoute>} />
            <Route path="edit/:id" element={
              <PrivateRoute>
                <MessageGroupEdit />
              </PrivateRoute>} />
          </Route>
          <Route path="/notifications">
            <Route index element={
              <PrivateRoute>
                <Notification />
              </PrivateRoute>} />
            <Route path="Create" element={
              <PrivateRoute>
                <NotificationCreate />
              </PrivateRoute>} />
            <Route path="edit/:id" element={
              <PrivateRoute>
                <NotificationCreate />
              </PrivateRoute>} />
            <Route path="view/:id" element={
              <PrivateRoute>
                <NotificationDetails />
              </PrivateRoute>} />
            <Route path="upload-notification" element={
              <PrivateRoute>
                <UploadNotification />
              </PrivateRoute>} />
          </Route>
          <Route path="/jee-marks">
            <Route index element={
              <PrivateRoute>
                <JeeMarks />
              </PrivateRoute>} />
            <Route path="Create" element={
              <PrivateRoute>
                <JeeMarksCalculateCreate />
              </PrivateRoute>} />
            <Route path="edit/:id" element={
              <PrivateRoute>
                <JeeMarksCalculateCreate />
              </PrivateRoute>} />
            <Route path="view/:id" element={
              <PrivateRoute>
                <JeeMarksDetails />
              </PrivateRoute>} />
          </Route>


          <Route path="/audit-users">
            <Route index element={
              <PrivateRoute>
                <AuditUsersList />
              </PrivateRoute>} />
            <Route path="create" element={
              <PrivateRoute>
                <CreateAuditUser />
              </PrivateRoute>} />
            <Route path="edit/:id" element={
              <PrivateRoute>
                <CreateAuditUser />
              </PrivateRoute>} />
          </Route>
          {/* <Route path="/classes">
            <Route index element={
              <PrivateRoute>
                <Classes />
              </PrivateRoute>} />
            <Route path="create" element={
              <PrivateRoute>
                <CreateUser />
              </PrivateRoute>} />
          </Route> */}
          <Route path="/subjects">
            <Route index element={
              <PrivateRoute>
                <Subjects />
              </PrivateRoute>} />
            <Route path="create" element={
              <PrivateRoute>
                <EditSubject />
              </PrivateRoute>} />
            <Route path="view/:id" element={
              <PrivateRoute>
                <SubjectDetails />
              </PrivateRoute>} />
            <Route path="edit/:id" element={
              <PrivateRoute>
                <EditSubject />
              </PrivateRoute>} />
          </Route>
          <Route path="/order-courses">
            <Route index element={
              <PrivateRoute>
                <Favourite />
              </PrivateRoute>}
            />
          </Route>
          <Route path="/popular-courses">
            <Route index element={
              <PrivateRoute>
                <PopularCourse />
              </PrivateRoute>}
            />
          </Route>
          <Route path="/category-management">
            <Route index element={
              <PrivateRoute>
                <Categories />
              </PrivateRoute>} />
            <Route path="create" element={
              <PrivateRoute>
                <CategoryCreate />
              </PrivateRoute>} />
            <Route path="edit/:id" element={
              <PrivateRoute>
                <EditCategory />
              </PrivateRoute>} />
            {/* <Route path="manage-subcategory">
              <Route index element={
                <PrivateRoute>
                  <Subcategories />
                </PrivateRoute>} />
              <Route path="create" element={
                <PrivateRoute>
                  <EditSubcategory />
                </PrivateRoute>} />
              <Route path="edit/:id" element={
                <PrivateRoute>
                  <EditSubcategory />
                </PrivateRoute>} />
            </Route> */}
          </Route>
          <Route path="/goal-management">
            <Route index element={
              <PrivateRoute>
                <Goal />
              </PrivateRoute>} />
            <Route path="create" element={
              <PrivateRoute>
                <EditGoal />
              </PrivateRoute>} />
            < Route path="edit/:id" element={
              <PrivateRoute>
                <EditGoal />
              </PrivateRoute>} />
          </Route>
          <Route path="/sample-paper">
            <Route index element={
              <PrivateRoute>
                <SamplePaper />
              </PrivateRoute>} />
            <Route path="create" element={
              <PrivateRoute>
                <EditSamplePaper />
              </PrivateRoute>} />
            < Route path="edit/:id" element={
              <PrivateRoute>
                <EditSamplePaper />
              </PrivateRoute>} />
          </Route>
          <Route path="/brochure">
            <Route index element={
              <PrivateRoute>
                <Brochure />
              </PrivateRoute>} />
            <Route path="create" element={
              <PrivateRoute>
                <EditBrochure />
              </PrivateRoute>} />
            < Route path="edit/:id" element={
              <PrivateRoute>
                <EditBrochure />
              </PrivateRoute>} />
          </Route>
          <Route path="/TestPattern">
            <Route index element={
              <PrivateRoute>
                <TestPattern />
              </PrivateRoute>} />
            <Route path="create" element={
              <PrivateRoute>
                <EditTestPattern />
              </PrivateRoute>} />
            < Route path="edit/:id" element={
              <PrivateRoute>
                <EditTestPattern />
              </PrivateRoute>} />
          </Route>
          <Route path="/static-content" >
            <Route index element={
              <PrivateRoute>
                <AppContent />
              </PrivateRoute>} />
            <Route path="create" element={
              <PrivateRoute>
                <CreateAppContent />
              </PrivateRoute>} />
            <Route path="edit/:id" element={
              <PrivateRoute>
                <CreateAppContent />
              </PrivateRoute>} />
            <Route path="view/:id" element={
              <PrivateRoute>
                <AppContentDetails />
              </PrivateRoute>} />
          </Route>

          <Route path="/settings" >
            <Route index element={
              <PrivateRoute>
                <Settings />
              </PrivateRoute>} />
            <Route path="edit/:id" element={
              <PrivateRoute>
                <EditSettings />
              </PrivateRoute>} />
            <Route path="view" element={
              <PrivateRoute>
                <ViewSettings />
              </PrivateRoute>} />
          </Route>

          <Route path="/company-detail" >
            <Route index element={
              <PrivateRoute>
                <CompanyDetailList />
              </PrivateRoute>} />
            <Route path="edit/:id" element={
              <PrivateRoute>
                <EditCompanyDetail />
              </PrivateRoute>} />
          </Route>

          <Route path="/quiz">
            <Route index element={
              <PrivateRoute>
                <QuizList />
              </PrivateRoute>} />
            <Route path="create" element={
              <PrivateRoute>
                <EditQuiz />
              </PrivateRoute>} />
            <Route path="edit/:id" element={
              <PrivateRoute>
                <EditQuiz />
              </PrivateRoute>} />
            <Route path="view/:id">
              <Route index element={
                <PrivateRoute>
                  <QuizDetails />
                </PrivateRoute>
              } />
              <Route path="upload-quiz-details" element={<PrivateRoute>
                <UploadQuiz />
              </PrivateRoute>} />
            </Route>
          </Route>

          <Route path="faculty-task">
            <Route index element={
              <PrivateRoute>
                <FacultyTaskList />
              </PrivateRoute>
            } />
            <Route path="create" element={
              <PrivateRoute>
                <FacultyTaskCreate />
              </PrivateRoute>} />
            <Route path="edit/:id" element={
              <PrivateRoute>
                <FacultyTaskCreate />
              </PrivateRoute>} />
          </Route>
          <Route path="my-tasks">
            <Route index element={
              <PrivateRoute>
                <MyTaskList />
              </PrivateRoute>
            } />
            {/* <Route path="create" element={
              <PrivateRoute>
                <FacultyTaskCreate />
              </PrivateRoute>} />
            <Route path="edit/:id" element={
              <PrivateRoute>
                <FacultyTaskCreate />
              </PrivateRoute>} /> */}
          </Route>
          <Route path="admin-user-batch">
            <Route index element={
              <PrivateRoute>
                <AdminUserBatchList />
              </PrivateRoute>
            } />
            <Route path="create" element={
              <PrivateRoute>
                <AdminUserBatchCreate />
              </PrivateRoute>} />
            <Route path="edit/:id" element={
              <PrivateRoute>
                <AdminUserBatchCreate />
              </PrivateRoute>} />
          </Route>
          <Route path="mentor-batch">
            <Route index element={
              <PrivateRoute>
                <MentorBatchList />
              </PrivateRoute>
            } />
            <Route path="create" element={
              <PrivateRoute>
                <MentorBatchCreate />
              </PrivateRoute>} />
            <Route path="edit/:id" element={
              <PrivateRoute>
                <MentorBatchCreate />
              </PrivateRoute>} />
          </Route>
          <Route path="mentor-teacher">
            <Route index element={
              <PrivateRoute>
                <MentorTeacherList />
              </PrivateRoute>
            } />
            <Route path="create" element={
              <PrivateRoute>
                <MentorTeacherCreate />
              </PrivateRoute>} />
            <Route path="edit/:id" element={
              <PrivateRoute>
                <MentorTeacherCreate />
              </PrivateRoute>} />
          </Route>
          <Route path="appointment">
            <Route index element={
              <PrivateRoute>
                <AllAppointmentList />
              </PrivateRoute>
            } />
            <Route path="create" element={
              <PrivateRoute>
                <AppointmentCreate />
              </PrivateRoute>} />
            <Route path="edit/:id" element={
              <PrivateRoute>
                <AppointmentCreate />
              </PrivateRoute>} />
          </Route>
          <Route path="my-appointment">
            <Route index element={
              <PrivateRoute>
                <UserAppointmentList />
              </PrivateRoute>
            } />
            {/* <Route path="create" element={
              <PrivateRoute>
                <AppointmentCreate />
              </PrivateRoute>} />
            <Route path="edit/:id" element={
              <PrivateRoute>
                <AppointmentCreate />
              </PrivateRoute>} /> */}
          </Route>
          <Route path="/batches">
            <Route index element={
              <PrivateRoute>
                <Batches />
              </PrivateRoute>
            } />
            <Route path="create" element={
              <PrivateRoute>
                <EditBatch />
              </PrivateRoute>} />
            <Route path="edit/:id" element={
              <PrivateRoute>
                <EditBatch />
              </PrivateRoute>} />
            <Route path="view/:id" element={
              <PrivateRoute>
                <BatchDetails />
              </PrivateRoute>} />
            <Route path="upload-batch" element={
              <PrivateRoute>
                <UploadBatch />
              </PrivateRoute>} />
          </Route>
          <Route path="/teacher-batches">
            <Route index element={
              <PrivateRoute>
                <ListTeacherBatches />
              </PrivateRoute>
            } />
          </Route>
          <Route path="/attendance">
            <Route index element={
              <PrivateRoute>
                <AttendanceList />
              </PrivateRoute>
            } />
            <Route path="review" element={
              <PrivateRoute>
                <ReviewAttendance />
              </PrivateRoute>} />
            <Route path="upload-attendance" element={
              <PrivateRoute>
                <UploadAttendance />
              </PrivateRoute>} />
          </Route>
          <Route path="/live-class-participant">
            <Route index element={
              <PrivateRoute>
                <LiveClassParticipantList />
              </PrivateRoute>
            } />
          </Route>

          <Route path="gate-pass">
            <Route index element={
              <PrivateRoute>
                <GatePassListing />
              </PrivateRoute>
            } />
            <Route path="new-gate-pass"
              element={<PrivateRoute>
                <NewGatePass />
              </PrivateRoute>} />
          </Route>
          <Route path="batch-change">
            <Route index element={
              <PrivateRoute>
                <BatchChanges />
              </PrivateRoute>
            } />
            <Route path="upload-batch-change"
              element={<PrivateRoute>
                <UploadBatchChanges />
              </PrivateRoute>} />
            <Route path="new-batch-change"
              element={<PrivateRoute>
                <NewBatchChanges />
              </PrivateRoute>} />
          </Route>

          <Route path="/batch-classes" >
            <Route index element={
              <PrivateRoute>
                <BatchClass />
              </PrivateRoute>} />
            <Route path="create" element={
              <PrivateRoute>
                <EditClass />
              </PrivateRoute>} />
            <Route path="edit/:id" element={
              <PrivateRoute>
                <EditClass />
              </PrivateRoute>} />
            <Route path="view/:id" element={
              <PrivateRoute>
                <BatchClassDetails />
              </PrivateRoute>} />
            <Route path="review" element={
              <PrivateRoute>
                <ReviewBatchClass />
              </PrivateRoute>} />
            <Route path="update" element={
              <PrivateRoute>
                <ModifyBatchClass />
              </PrivateRoute>} />
            <Route path="modify-batch-class" element={
              <PrivateRoute>
                <UploadBatchClass modify={true} />
              </PrivateRoute>} />
            <Route path="upload-batch-class" element={
              <PrivateRoute>
                <UploadBatchClass />
              </PrivateRoute>} />
          </Route>
          <Route path="/current-classes" >
            <Route index element={
              <PrivateRoute>
                <CurrentClassList />
              </PrivateRoute>} />
            <Route path="create" element={
              <PrivateRoute>
                <EditCurrentClass />
              </PrivateRoute>} />
            <Route path="edit/:id" element={
              <PrivateRoute>
                <EditCurrentClass />
              </PrivateRoute>} />
          </Route>
          <Route path="/campus" >
            <Route index element={
              <PrivateRoute>
                <CampusList />
              </PrivateRoute>} />
            <Route path="create" element={
              <PrivateRoute>
                <EditCreateCampus />
              </PrivateRoute>} />
            <Route path="edit/:id" element={
              <PrivateRoute>
                <EditCreateCampus />
              </PrivateRoute>} />
          </Route>
          <Route path="/campus-cities" >
            <Route index element={
              <PrivateRoute>
                <CampusCitiesList />
              </PrivateRoute>} />
            <Route path="create" element={
              <PrivateRoute>
                <EditCreateCampusCities />
              </PrivateRoute>} />
            <Route path="edit/:id" element={
              <PrivateRoute>
                <EditCreateCampusCities />
              </PrivateRoute>} />
          </Route>
          <Route path="/incomplete-students">
            <Route index element={
              <PrivateRoute>
                <InCompleteStudents />
              </PrivateRoute>
            } />
          </Route>
          <Route path="/students">
            <Route index element={
              <PrivateRoute>
                <Students />
              </PrivateRoute>
            } />
            <Route path="create" element={
              <PrivateRoute>
                <EditStudent />
              </PrivateRoute>
            } />
            <Route path="edit/:id" element={
              <PrivateRoute>
                <EditStudent />
              </PrivateRoute>
            } />
            <Route path="view/:id" element={
              <PrivateRoute>
                <StudentsDetails />
              </PrivateRoute>
            } />
            <Route path="upload" element={
              <PrivateRoute>
                <UploadStudents />
              </PrivateRoute>
            } />
            <Route path="updateClass" element={
              <PrivateRoute>
                <UpdateCurrentClass />
              </PrivateRoute>
            } />
            <Route path="extends">
              <Route index element={
                <PrivateRoute>
                  <ExtendsStudents />
                </PrivateRoute>
              } />
              <Route path="create" element={
                <PrivateRoute>
                  <CreateExtandsUser />
                </PrivateRoute>
              } />
              <Route path="edit/:id" element={
                <PrivateRoute>
                  <CreateExtandsUser />
                </PrivateRoute>
              } />
            </Route>
          </Route>

          <Route path="/discounts">
            <Route index element={
              <PrivateRoute>
                <ListDiscount />
              </PrivateRoute>} />

            <Route path="promotional-code-users/:id" element={
              <PrivateRoute>
                <PromotionalCodeUsers />
              </PrivateRoute>} />

            <Route path="create" element={
              <PrivateRoute>
                <Discount />
              </PrivateRoute>} />
            <Route path="edit/:id" element={
              <PrivateRoute>
                <Discount />
              </PrivateRoute>} />
            <Route path="upload-promo-code" element={<PrivateRoute>
              <UploadPromotionalCode />
            </PrivateRoute>}
            />
          </Route>
          <Route path="/course-change">
            <Route index element={
              <PrivateRoute>
                <CourseChangeList />
              </PrivateRoute>} />
            <Route path="create" element={
              <PrivateRoute>
                <CourseChange />
              </PrivateRoute>} />
            <Route path="edit/:id" element={
              <PrivateRoute>
                <CourseChange />
              </PrivateRoute>} />
          </Route>

          {/* <Route path="/channelPartners">
            <Route index element={
              <PrivateRoute>
                <ChannelPartners />
              </PrivateRoute>} />
            <Route path="view/:id" element={
              <PrivateRoute>
                <ChannelPartnerDetails />
              </PrivateRoute>} />
          </Route>*/}
          <Route path="/edit-profile">
            <Route index element={
              <PrivateRoute>
                <EditProfile />
              </PrivateRoute>}
            />
          </Route>
          <Route path="/support">
            <Route index element={
              <PrivateRoute>
                <Support />
              </PrivateRoute>}
            />
          </Route>
          {/* <Route path="/user-support">
            <Route index element={
              <PrivateRoute>
                <UserSupport />
              </PrivateRoute>}
            />
          </Route>
          <Route path="/master-password">
            <Route index element={
              <PrivateRoute>
                <MasterPasswordProfile />
              </PrivateRoute>}
            />
          </Route>
          
          <Route path="/order-category">
            <Route index element={
              <PrivateRoute>
                <FavouriteCategory />
              </PrivateRoute>}
            />
          </Route>
          <Route path="/order-subcategory">
            <Route index element={
              <PrivateRoute>
                <FavouriteSubCategory />
              </PrivateRoute>}
            />
          </Route> */}
          <Route path="/gallery-event">
            <Route index element={
              <PrivateRoute>
                <GalleryEventList />
              </PrivateRoute>} />
            <Route path="manage/:id" element={
              <PrivateRoute>
                <AddEditGalleryPhotos />
              </PrivateRoute>} />
          </Route>
          <Route path="/quick-registration">
            <Route index element={
              <PrivateRoute>
                <CoureRegistration />
              </PrivateRoute>} />
          </Route>
          <Route path="/offline-payment">
            <Route index element={
              <PrivateRoute>
                <OfflinePaymentCreate />
              </PrivateRoute>} />
          </Route>
          <Route path="/challan">
            <Route index element={
              <PrivateRoute>
                <ChallanList />
              </PrivateRoute>} />
          </Route>
          <Route path="/invoices">
            <Route index element={
              <PrivateRoute>
                <OrderList />
              </PrivateRoute>}
            />
            <Route path="view/:orderId" element={
              <PrivateRoute>
                <OrderDetails />
              </PrivateRoute>}
            />
          </Route>
          <Route path="/incomplete-purchases">
            <Route index element={
              <PrivateRoute>
                <IncompleteOrderList />
              </PrivateRoute>}
            />
            {/* <Route path="view/:orderId" element={
              <PrivateRoute>
                <OrderDetails />
              </PrivateRoute>}
            /> */}
          </Route>

          <Route path="/sidebar-manage">
            <Route index element={
              <PrivateRoute>
                <StudentSidebarManage />
              </PrivateRoute>}
            />
          </Route>

          {/* <Route path="/testimonials">
            <Route index element={
              <PrivateRoute>
                <TestimonialList />
              </PrivateRoute>}
            />
            <Route path="create" element={
              <PrivateRoute>
                <TestimonialCreate />
              </PrivateRoute>} />
            <Route path="edit/:id" element={
              <PrivateRoute>
                <TestimonialEdit />
              </PrivateRoute>} />
            <Route path="view/:id" element={
              <PrivateRoute>
                <TestimonialDetails />
              </PrivateRoute>}
            />
          </Route> */}

          {/* <Route path="/download-management">
            <Route index element={
              <PrivateRoute>
                <Download />
              </PrivateRoute>} />
            <Route path="create" element={
              <PrivateRoute>
                <DownloadCreate />
              </PrivateRoute>} />
            <Route path="edit/:id" element={
              <PrivateRoute>
                <DownloadCreate />
              </PrivateRoute>} />
            <Route path="manage-subcategory/:categoryId">
              <Route index element={
                <PrivateRoute>
                  <DownloadSubCategory />
                </PrivateRoute>} />
              <Route path="create" element={
                <PrivateRoute>
                  <CreateDownloadSubcategory />
                </PrivateRoute>} />
              <Route path="edit/:id" element={
                <PrivateRoute>
                  <CreateDownloadSubcategory />
                </PrivateRoute>} />
            </Route>

          </Route> */}

          {/* <Route path="download-group-management">
            <Route index element={
              <PrivateRoute>
                <DownloadGroup />
              </PrivateRoute>} />
            <Route path="create" element={
              <PrivateRoute>
                <CreateDownloadGroup />
              </PrivateRoute>} />
            <Route path="edit/:id" element={
              <PrivateRoute>
                <CreateDownloadGroup />
              </PrivateRoute>} />
          </Route> */}


          {/* <Route path="downloads">
            <Route index element={
              <PrivateRoute>
                <Downloads />
              </PrivateRoute>} />
            <Route path="create" element={
              <PrivateRoute>
                <CreateDownloads />
              </PrivateRoute>} />
            <Route path="edit/:id" element={
              <PrivateRoute>
                <CreateDownloads />
              </PrivateRoute>} />
          </Route> */}

          <Route path="live-classes" element={<PrivateRoute><ZoomClasses /></PrivateRoute>} />
          {/* <Route path="audit-process" element={<PrivateRoute><AuditProcess /></PrivateRoute>} /> */}

          {/* <Route path="class-attendance" >
            <Route index element={
              <PrivateRoute>
                <ClassAttendance />
              </PrivateRoute>} />
          </Route>
          <Route path="report-analysis" >
            <Route index element={
              <PrivateRoute>
                <ReportAnalysis />
              </PrivateRoute>} />
          </Route> */}
          <Route path="register-user-report" >
            <Route index element={
              <PrivateRoute>
                <RegUserReportAnalysis />
              </PrivateRoute>} />
          </Route>
          <Route path="user-report" >
            <Route index element={
              <PrivateRoute>
                <UserReportAnalysis />
              </PrivateRoute>} />
          </Route>
          <Route path="FPR-report" >
            <Route index element={
              <PrivateRoute>
                <FPRReport />
              </PrivateRoute>} />
            <Route path="view/:id" element={
              <PrivateRoute>
                <FPRReportView />
              </PrivateRoute>} />
          </Route>
          <Route path="/spark-student">
            <Route index element={
              <PrivateRoute>
                <ListSparkStudents />
              </PrivateRoute>
            } />
            <Route path="create" element={
              <PrivateRoute>
                <EditSparkStudent />
              </PrivateRoute>} />
            <Route path="edit/:id" element={
              <PrivateRoute>
                <EditSparkStudent />
              </PrivateRoute>} />
            <Route path="upload" element={
              <PrivateRoute>
                <UploadSparkStudent />
              </PrivateRoute>} />
            <Route path="SPR/:id" element={
              <PrivateRoute>
                <SPR showFilter={false} />
              </PrivateRoute>} />
          </Route>
          <Route path="hostel" >
            <Route index element={
              <PrivateRoute>
                <ListHostel />
              </PrivateRoute>} />
            <Route path="create" element={
              <PrivateRoute>
                <EditHostel />
              </PrivateRoute>} />
            <Route path="edit/:id" element={
              <PrivateRoute>
                <EditHostel />
              </PrivateRoute>} />
            {/* <Route path="view/:id" element={
              <PrivateRoute>
                <FPRReportView />
              </PrivateRoute>} /> */}
          </Route>
          <Route path="spark-management" >
            <Route index element={
              <PrivateRoute>
                <ListSparkRegistration />
              </PrivateRoute>} />
            <Route path="create" element={
              <PrivateRoute>
                <EditRegistration />
              </PrivateRoute>} />
            <Route path="edit/:id" element={
              <PrivateRoute>
                <EditRegistration />
              </PrivateRoute>} />
            <Route path="clone/:id" element={
              <PrivateRoute>
                <EditRegistration isClone={true} />
              </PrivateRoute>} />
            <Route path="view/:id" element={
              <PrivateRoute>
                <ViewRegistration />
              </PrivateRoute>} />
            <Route path="SPR/:id" element={
              <PrivateRoute>
                <SPR showFilter={false} />
              </PrivateRoute>} />
          </Route>
          <Route path="/my-class-report" >
            <Route index element={
              <PrivateRoute>
                <FPRReportView />
              </PrivateRoute>} />
          </Route>
          <Route path="profile-report" >
            <Route index element={
              <PrivateRoute>
                <ProfileReport />
              </PrivateRoute>} />
          </Route>
          <Route path="/ddriowkd394m3k59akd448293kdahd" >
            <Route index element={
              <PrivateRoute>
                <RevenueReport />
              </PrivateRoute>} />
          </Route>
          <Route path="admission-report" >
            <Route index element={
              <PrivateRoute>
                <AdmissionReport />
              </PrivateRoute>} />
          </Route>
          <Route path="faculty-balance-report" >
            <Route index element={
              <PrivateRoute>
                <FacultyLoadBalanceReport />
              </PrivateRoute>} />
          </Route>
          <Route path="head-office-registration" >
            <Route index element={
              <PrivateRoute>
                <HeadOfficeRegistration />
              </PrivateRoute>} />
          </Route>
          <Route path="student-academic-data" >
            <Route index element={
              <PrivateRoute>
                <StudentAcademicData />
              </PrivateRoute>} />
          </Route>
          <Route path="batch-report" >
            <Route index element={
              <PrivateRoute>
                <BatchReport />
              </PrivateRoute>} />
          </Route>
          <Route path="course-registration-count-report" >
            <Route index element={
              <PrivateRoute>
                <CourseStudentCountReport />
              </PrivateRoute>} />
          </Route>
          <Route path="test-engagement" >
            <Route index element={
              <PrivateRoute>
                <TestEngagement />
              </PrivateRoute>} />
          </Route>
          <Route path="/landing-registration" >
            <Route index element={
              <PrivateRoute>
                <LandingPageRegisterList />
              </PrivateRoute>} />
          </Route>
          {/* <Route path="teacher-engagement" >
            <Route index element={
              <PrivateRoute>
                <TeacherAttendance />
              </PrivateRoute>} />
            <Route path=":id" element={
              <PrivateRoute>
                <TeacherEngagement />
              </PrivateRoute>} />
          </Route> */}

          <Route path="sms-panel" >
            <Route index element={
              <PrivateRoute>
                <SmsList />
              </PrivateRoute>} />
            <Route path="create" element={
              <PrivateRoute>
                <SmsCreate />
              </PrivateRoute>} />
            <Route path="view/:id" element={
              <PrivateRoute>
                <SMSDetails />
              </PrivateRoute>} />
            <Route path="upload-sms" element={
              <PrivateRoute>
                <UploadSmsPanel />
              </PrivateRoute>} />
          </Route>
          {/* <Route path="sms-log-pannel" >
            <Route index element={
              <PrivateRoute>
                <SmsLogList />
              </PrivateRoute>} />
              <Route path="view/:id" element={
              <PrivateRoute>
                <SMSDetails />
              </PrivateRoute>} />
          </Route> */}

          <Route path="banner" >
            <Route index element={
              <PrivateRoute>
                <BannerList />
              </PrivateRoute>} />
            <Route path="create" element={
              <PrivateRoute>
                <CreateBanner />
              </PrivateRoute>} />
            <Route path="edit/:id" element={
              <PrivateRoute>
                <CreateBanner />
              </PrivateRoute>} />
            <Route path="view/:id" element={
              <PrivateRoute>
                <SMSDetails />
              </PrivateRoute>} />

          </Route>
          <Route path="result-banner" >
            <Route index element={
              <PrivateRoute>
                <ResultBannerList />
              </PrivateRoute>} />
            <Route path="create" element={
              <PrivateRoute>
                <ResultCreateBanner />
              </PrivateRoute>} />
            <Route path="edit/:id" element={
              <PrivateRoute>
                <ResultCreateBanner />
              </PrivateRoute>} />
          </Route>
          <Route path="admission-enquiry" >
            <Route index element={
              <PrivateRoute>
                <EnquiriesList />
              </PrivateRoute>} />
            <Route path="create" element={
              <PrivateRoute>
                <EnquiryCreate />
              </PrivateRoute>} />
            <Route path="edit/:id" element={
              <PrivateRoute>
                <EnquiryCreate />
              </PrivateRoute>} />
          </Route>
          <Route path="call-back-request" >
            <Route index element={
              <PrivateRoute>
                <CallbackEnquiriesList />
              </PrivateRoute>} />
          </Route>
          <Route path="master-admission-enquiry" >
            <Route index element={
              <PrivateRoute>
                <MasterEnquiriesList />
              </PrivateRoute>} />
          </Route>
          <Route path="agent-enquiry" >
            <Route index element={
              <PrivateRoute>
                <AgentEnquiriesList />
              </PrivateRoute>} />
            <Route path="edit/:id" element={
              <PrivateRoute>
                <AgentEnquiryEdit />
              </PrivateRoute>} />
          </Route>
          <Route path="master-agent-enquiry" >
            <Route index element={
              <PrivateRoute>
                <MasterAgentEnquiriesList />
              </PrivateRoute>} />
            <Route path="edit/:id" element={
              <PrivateRoute>
                <MasterAgentEnquiryEdit />
              </PrivateRoute>} />
            <Route path="upload-agent-task" element={
              <PrivateRoute>
                <UploadAgentTasks />
              </PrivateRoute>} />
            <Route path="assign-agent-task" element={
              <PrivateRoute>
                <UploadAgentTasks uploadType={'update'} />
              </PrivateRoute>} />
          </Route>
          <Route path="parent-support" >
            <Route index element={
              <PrivateRoute>
                <ParentSupportList />
              </PrivateRoute>} />
            <Route path="edit/:id" element={
              <PrivateRoute>
                <ParentSupportEdit />
              </PrivateRoute>} />
          </Route>
          <Route path="parent-support-access">
            <Route index element={
              <PrivateRoute>
                <ParentSupportAccessList />
              </PrivateRoute>
            } />
            {/* <Route path="create" element={
              <PrivateRoute>
                <ParentSupportAccessCreate />
              </PrivateRoute>} /> */}
            <Route path="edit/:id" element={
              <PrivateRoute>
                <ParentSupportAccessCreate />
              </PrivateRoute>} />
          </Route>
          <Route path="id-cards" >
            <Route index element={
              <PrivateRoute>
                <IdCardList />
              </PrivateRoute>} />
            <Route path="upload-idcard-status" element={
              <PrivateRoute>
                <UploadIDCardStatus />
              </PrivateRoute>} />
          </Route>
          {/* <Route path="/teacher-calendar"
            element={<PrivateRoute>
              <TeacherCalendar />
            </PrivateRoute>}
          >
          </Route> */}


          {/* <Route path="/handout-user">
            <Route index element={
              <PrivateRoute>
                <HandoutUser />
              </PrivateRoute>
            } />
            <Route path="create" element={
              <PrivateRoute>
                <CreateHandoutUser />
              </PrivateRoute>
            } />

            <Route path="edit/:id" element={
              <PrivateRoute>
                <CreateHandoutUser />
              </PrivateRoute>
            } />

          </Route> */}


          {/* <Route path="/course-handout">
            <Route index element={
              <PrivateRoute>
                <CourseHandoutList />
              </PrivateRoute>
            } />
            <Route path="create" element={
              <PrivateRoute>
                <CreateHandout />
              </PrivateRoute>
            } />

            <Route path="edit/:id" element={
              <PrivateRoute>
                <CreateHandout />
              </PrivateRoute>
            } />

            <Route path="view/:id" element={
              <PrivateRoute>
                <HandoutViewDetails />
              </PrivateRoute>
            } />

          </Route> */}

          {/*  exams  */}
          <Route path="/exam-calendar">
            <Route index element={
              <PrivateRoute>
                <ExamCalendar />
              </PrivateRoute>
            } />
            <Route path="Create" element={
              <PrivateRoute>
                <ExamCalendarEdit />
              </PrivateRoute>
            } />
            <Route path={`edit/:id`} element={
              <PrivateRoute>
                <ExamCalendarEdit />
              </PrivateRoute>
            } />
          </Route>
          <Route path="/exam-center">
            <Route index element={
              <PrivateRoute>
                <ExamCenterList />
              </PrivateRoute>
            } />
            <Route path="Create" element={
              <PrivateRoute>
                <CreateExamCenter />
              </PrivateRoute>
            } />
            <Route path={`edit/:id`} element={
              <PrivateRoute>
                <CreateExamCenter />
              </PrivateRoute>
            } />
          </Route>
          <Route path="/e-subjectGoals">
            <Route index element={
              <PrivateRoute>
                <ESubjectGoalsList />
              </PrivateRoute>
            } />
            <Route path="create" element={
              <PrivateRoute>
                <CreateESubjectGoals />
              </PrivateRoute>
            } />
            <Route path={`edit/:id`} element={
              <PrivateRoute>
                <CreateESubjectGoals />
              </PrivateRoute>
            } />
          </Route>



          <Route path="/e-subject">
            <Route index element={
              <PrivateRoute>
                <ExamSubject />
              </PrivateRoute>
            } />
            <Route path="create" element={
              <PrivateRoute>
                <CreateESubject />
              </PrivateRoute>
            } />
            <Route path={`edit/:id`} element={
              <PrivateRoute>
                <CreateESubject />
              </PrivateRoute>
            } />
            <Route path={`view/:id`} element={
              <PrivateRoute>
                <EsubjectDetails />
              </PrivateRoute>
            } />
            {/* <Route path="upload-topics/:id" element={
              <PrivateRoute>
                <UploadTopicSubTopic />
              </PrivateRoute>} /> */}
          </Route>

          <Route path="/question-type">
            <Route index element={
              <PrivateRoute>
                <QuestionTypeList />
              </PrivateRoute>} />
            <Route path="Create" element={
              <PrivateRoute>
                <QuestionTypeCreate />
              </PrivateRoute>} />
            <Route path="edit/:id" element={
              <PrivateRoute>
                <QuestionTypeCreate />
              </PrivateRoute>} />
          </Route>
          <Route path="/manage-rules">
            <Route index element={
              <PrivateRoute>
                <ManageRules />
              </PrivateRoute>
            } />
            <Route path="create" element={
              <PrivateRoute>
                <CreateRules />
              </PrivateRoute>
            } />

            <Route path="edit/:id" element={
              <PrivateRoute>
                <CreateRules />
              </PrivateRoute>
            } />
          </Route>

          <Route path="/paper-type">
            <Route index element={
              <PrivateRoute>
                <PaperTypeList />
              </PrivateRoute>} />
            <Route path="Create" element={
              <PrivateRoute>
                <PaperTypeCreate />
              </PrivateRoute>} />
            <Route path="edit/:id" element={
              <PrivateRoute>
                <PaperTypeCreate />
              </PrivateRoute>} />
          </Route>

          <Route path="/subject-paper">
            <Route index element={
              <PrivateRoute>
                <SubjectPaperList />
              </PrivateRoute>} />
            <Route path="Create" element={
              <PrivateRoute>
                <SubjectPaperCreate />
              </PrivateRoute>} />
            <Route path="edit/:id" element={
              <PrivateRoute>
                <SubjectPaperCreate />
              </PrivateRoute>} />
            <Route path="view/:id" element={
              <PrivateRoute>
                <SubjectPaperView />
              </PrivateRoute>} />
            <Route path="preview/:id" element={
              <PrivateRoute>
                <SubjectPaperPreview />
              </PrivateRoute>} />
            <Route path="upload/:id" element={
              <PrivateRoute>
                <UploadSubjectQuestion />
              </PrivateRoute>} />
          </Route>
          <Route path="/difficulty-level">
            <Route index element={
              <PrivateRoute>
                <DifficultyLevelList />
              </PrivateRoute>} />
            <Route path="Create" element={
              <PrivateRoute>
                <DifficultyLevelCreate />
              </PrivateRoute>} />
            <Route path="edit/:id" element={
              <PrivateRoute>
                <DifficultyLevelCreate />
              </PrivateRoute>} />
          </Route>
          <Route path="/section-name">
            <Route index element={
              <PrivateRoute>
                <SectionNameList />
              </PrivateRoute>} />
            <Route path="Create" element={
              <PrivateRoute>
                <SectionNameCreate />
              </PrivateRoute>} />
            <Route path="edit/:id" element={
              <PrivateRoute>
                <SectionNameCreate />
              </PrivateRoute>} />
          </Route>

          {/* <Route path="/review-course-handout">
            <Route index element={
              <PrivateRoute>
                < ReviewHandoutList />
              </PrivateRoute>
            } />

            <Route path="edit/:id" element={
              <PrivateRoute>
                <ReviewEditHandout />
              </PrivateRoute>
            } />
            <Route path="view/:id" element={
              <PrivateRoute>
                <HandoutViewDetails />
              </PrivateRoute>
            } />
          </Route>
          <Route path="/payment-link">
            <Route index element={
              <PrivateRoute>
                <PaymentLinkList />
              </PrivateRoute>
            } />
            <Route path="view/:id" element={
              <PrivateRoute>
                <PaymentLinkDetails />
              </PrivateRoute>
            } />
            <Route path="Create" element={
              <PrivateRoute>
                <PaymentLinkCreate />
              </PrivateRoute>
            } />
          </Route> */}
          <Route path="/scholarships">
            <Route index element={
              <PrivateRoute>
                <ListScholarship />
              </PrivateRoute>
            } />
            <Route path="create" element={
              <PrivateRoute>
                <EditScholarship />
              </PrivateRoute>} />
            <Route path="edit/:id" element={
              <PrivateRoute>
                <EditScholarship />
              </PrivateRoute>} />
            <Route path="view/:id" element={
              <PrivateRoute>
              </PrivateRoute>} />
            <Route path="upload-batch" element={
              <PrivateRoute>
                <UploadScholarship />
              </PrivateRoute>} />
          </Route>
          <Route path="/installment">
            <Route index element={
              <PrivateRoute>
                <InstallmentList />
              </PrivateRoute>
            } />
            <Route path="view/:cid/:sid" element={
              <PrivateRoute>
                <InstallmentDetails />
              </PrivateRoute>} />
          </Route>
          <Route path="/feedback-questions">
            <Route index element={
              <PrivateRoute>
                <QuestionsList />
              </PrivateRoute>} />
            <Route path="Create" element={
              <PrivateRoute>
                <QuestionsCreate />
              </PrivateRoute>} />
            <Route path="edit/:id" element={
              <PrivateRoute>
                <QuestionsCreate />
              </PrivateRoute>} />
          </Route>
          <Route path="/manage-feedbacks">
            <Route index element={
              <PrivateRoute>
                <FeedbacksList />
              </PrivateRoute>
            } />
            <Route path="Create" element={
              <PrivateRoute>
                <FeedbackCreate />
              </PrivateRoute>} />
            <Route path="edit/:id" element={
              <PrivateRoute>
                <FeedbackCreate />
              </PrivateRoute>} />
            <Route path="review" element={
              <PrivateRoute>
                <ReviewFeedbacks />
              </PrivateRoute>} />
            <Route path="upload-feedbacks" element={
              <PrivateRoute>
                <UploadFeedbacks />
              </PrivateRoute>} />
          </Route>
          <Route path="/teacher-feedback">
            <Route index element={
              <PrivateRoute>
                <TeacherFeedbacksList />
              </PrivateRoute>
            } />
            <Route path="view/:id" element={
              <PrivateRoute>
                <TeacherFeedbackView />
              </PrivateRoute>} />
            <Route path="report" element={
              <PrivateRoute>
                <TeacherFeedbackReport />
              </PrivateRoute>} />
          </Route>
          <Route path="/my-feedback">
            <Route index element={
              <PrivateRoute>
                <TeacherFeedbackView />
              </PrivateRoute>} />
          </Route>
          <Route path="/academic-year">
            <Route index element={
              <PrivateRoute>
                <AcademicYearList />
              </PrivateRoute>} />
            <Route path="Create" element={
              <PrivateRoute>
                <AcademicYearCreate />
              </PrivateRoute>} />
            <Route path="edit/:id" element={
              <PrivateRoute>
                <AcademicYearCreate />
              </PrivateRoute>} />
          </Route>
        </Routes>
        <Toast />
      </Suspense>
      {showNavBar() && <Footer />}
    </div >
  );
}

const PrivateRoute = ({ children, ...rest }) => {
  const { user } = useSelector(state => state.auth);
  if (!user) {
    return <Navigate to="/" replace />;
  }

  return (
    <Suspense fallback={<FallBack />}>
      {children}
    </Suspense>
  );
}

export default App;
